export default "__VITE_ASSET__74cc9b00__"